module.exports = __webpack_public_path__ + "static/media/logo.7c15de5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 769
// module chunks = 0